import styled from '@xstyled/styled-components';

/**
 * Numeric hotspot marker. Flex + line-height 1 centers the glyph in the
 * circle; OS-specific font metrics (macOS Core Text vs Windows DirectWrite)
 * otherwise shift Plus Jakarta digits inside a 22px line box.
 */
export const HotspotNumberLabel = styled.span<{ $fontSize?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  text-align: center;
  font-variant-numeric: lining-nums tabular-nums;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: ${p => p.$fontSize ?? 18}px;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
`;
